import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useCreateDesignCombinatoinMutation,
  useDeleteDesignCombinatoinMutation,
  useGetAllCarryingElementsQuery,
  useGetDesignCombinationAllQuery,
  useUpdateCarryElementMutation,
  useUpdateDesignCombinatoinMutation,
} from "../../services/API/titanApi.js";
import {
  selectAddNewState,
  selectCurrentTable,
  setAddNewState,
  setCurrentTable,
} from "../../store/slices/dataTablesSlice";
import CarryingElements from "../DataTables/CarryingElements";
import DesignCombinations from "../DataTables/DesignCombinations";
import "./TablesBasePage.scss";
import { TableTitle } from "./TableTitle";

export function TablesBasePageAASHTO() {
  const tableTitle = useSelector(selectCurrentTable);
  const [updateCarryingElement] = useUpdateCarryElementMutation();
  const [createDesignCombination] = useCreateDesignCombinatoinMutation();
  const [updateDesignCombination] = useUpdateDesignCombinatoinMutation();
  const [deleteDesignCombination] = useDeleteDesignCombinatoinMutation();

  const isNewStateOn = useSelector(selectAddNewState);
  const dispatch = useDispatch();

  const designCombinationFunctions = {
    abort: abort,
    getNew: getEmptyObject,
    addNew: async (localdata) => {
      try {
        await createDesignCombination(localdata).unwrap();
      } catch (error) {
        console.error("in Tragglieder addNew: ", error);
      }
      dispatch(setAddNewState(false));
    },
    delete: async (id) => {
      try {
        await deleteDesignCombination({ id });
      } catch (error) {
        console.error("error ", error);
      }
    },
    update: async (localdata) => {
      try {
        await updateDesignCombination({
          id: localdata._id,
          element: localdata,
        }).unwrap();
      } catch (error) {
        console.error("in Update: ", error);
      }
      dispatch(setAddNewState(false));
    },
    GetAll: () => {
      return useGetDesignCombinationAllQuery();
    },
  };

  const carryingElementFunctions = {
    abort: abort,
    //getNew: getEmptyObject,
    // addNew: async (localdata) => {
    //   try {
    //     await addNewCarryingElement(localdata).unwrap();
    //   } catch (error) {
    //     console.error("in Update: ", error);
    //   }
    //   dispatch(setAddNewState(false));
    // },
    // delete: async (id) => {
    //   try {
    //     await deleteCarryingElement({ id });
    //   } catch (error) {
    //     console.error("error ", error);
    //   }
    //   dispatch(setAddNewState(false));
    // },
    GetAll: () => {
      return useGetAllCarryingElementsQuery();
    },
    update: async (localdata) => {
      try {
        await updateCarryingElement({
          id: localdata._id,
          element: localdata,
        }).unwrap();
      } catch (error) {
        console.error("in Update: ", error);
      }
    },
  };

  const titlesConfig = [
    {
      title: "Carrying elements",
      component: <CarryingElements functions={carryingElementFunctions} />,
      functions: carryingElementFunctions,
    },
    {
      title: "DesignCombinations",
      component: <DesignCombinations functions={designCombinationFunctions} />,
      functions: designCombinationFunctions,
    },
  ];

  function abort() {
    dispatch(setAddNewState(false));
  }

  function getEmptyObject() {
    return {};
  }

  const [currentComponent, setCurrentComponent] = useState(
    titlesConfig.find((obj) => {
      return obj.title === tableTitle.aashto;
    }).component
  );

  const [currentFunctions, setCurrentFunctions] = useState(
    titlesConfig.find((obj) => {
      return obj.title === tableTitle.aashto;
    }).functions
  );

  function onSelectedChanged(title) {
    dispatch(setCurrentTable({ ...tableTitle, aashto: title }));
    setCurrentComponent(getCurrent(title).component);
    setCurrentFunctions(getCurrent(title).functions);
  }

  useEffect(() => {
    setCurrentComponent(getCurrent(tableTitle.aashto)?.component);
  }, [tableTitle.aashto, isNewStateOn]);

  useEffect(() => {
    setCurrentComponent(getCurrent(tableTitle.aashto)?.component);
    setCurrentFunctions(getCurrent(tableTitle.aashto)?.functions);
  }, [tableTitle.aashto]);

  function getCurrent(title) {
    let result = titlesConfig.find((item) => item.title == title) || null;
    return result;
  }

  return (
    <div className="TablesBasePage">
      <div className="container-fluid">
        <div className="table-wrapper">
          <TableTitle
            tableTitle={tableTitle.aashto}
            titles={titlesConfig}
            functions={currentFunctions}
            onSelectedChanged={onSelectedChanged}
          />
          {currentComponent || <div>Daten tabelle noch nicht aktiv</div>}
        </div>
      </div>
    </div>
  );
}

export default TablesBasePageAASHTO;
